import React from "react";
import PropTypes from "prop-types";
import { Alert } from "@opendate-app/setlist";
import "./classesShared.css";

export default function TintedAlert({ color = "brand", title, description, icon, actions, className = "" }) {
  return (
    <Alert
      className={`classes-tinted-alert classes-tinted-alert--${color} ${className}`.trim()}
      color={color}
      role={color === "error" ? "alert" : "status"}
      title={title}
      description={description}
      icon={icon}
      actions={actions}
    />
  );
}

TintedAlert.propTypes = {
  color: PropTypes.oneOf(["brand", "warning", "error", "success"]),
  title: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.elementType,
  actions: PropTypes.node,
  className: PropTypes.string,
};
